var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"login-message"},[_c('h4',[_vm._v("登录操作通知")]),_c('p',[_vm._v("登录时间："+_vm._s(_vm.datetime)+" (CST)")]),_c('p',[_vm._v("IP地址："+_vm._s(_vm.ip))]),_c('p',[_vm._v("登录地点："+_vm._s(_vm.address))]),_c('p',[_vm._v("登录设备："+_vm._s(_vm.platform))]),_c('p',[_vm._v("异常原因："+_vm._s(_vm.reason))])])
}
var staticRenderFns = []

export { render, staticRenderFns }